import type { Question } from '@/domain/question'

// Seed questions for the three placeholder episodes. Not rendered by any P0
// screen — present so the Quiz Engine (P1) starts against real data
// instead of designing question shape from scratch (Document 11 §6/§11).
export const seedQuestions: Question[] = [
  {
    id: 'q-phish-1',
    episodeId: 'ep-phishing-trap',
    quizId: 'quiz-phishing-101',
    type: 'multiple_choice',
    stem: "Amaka gets an email saying her bank account will be closed in 1 hour unless she clicks a link. What's the safest first move?",
    options: [
      { id: 'a', text: 'Click the link immediately to avoid losing the account' },
      { id: 'b', text: 'Open her banking app directly (not via the email) to check account status' },
      { id: 'c', text: 'Reply to the email asking if it is real' },
      { id: 'd', text: 'Forward the email to a friend for a second opinion' },
    ],
    correctOptionIds: ['b'],
    explanation:
      'Legitimate banks never require you to act within minutes via an email link. Always verify through an official app or number you already trust — never a link in the message itself.',
    difficulty: 'beginner',
  },
  {
    id: 'q-phish-2',
    episodeId: 'ep-phishing-trap',
    quizId: 'quiz-phishing-101',
    type: 'true_false',
    stem: 'Urgency and fear are common tactics used in phishing emails.',
    options: [
      { id: 'true', text: 'True' },
      { id: 'false', text: 'False' },
    ],
    correctOptionIds: ['true'],
    explanation: 'Creating panic reduces careful thinking — which is exactly what phishing attempts rely on.',
    difficulty: 'beginner',
  },
  {
    id: 'q-simswap-1',
    episodeId: 'ep-simswap-shadows',
    quizId: 'quiz-simswap-101',
    type: 'scenario',
    stem: 'Your phone suddenly shows "No Service" for hours with no explanation. What should you do first?',
    options: [
      { id: 'a', text: 'Wait a day to see if it resolves itself' },
      { id: 'b', text: 'Contact your mobile network operator immediately to check for an unauthorized SIM swap' },
      { id: 'c', text: 'Restart your phone repeatedly' },
      { id: 'd', text: 'Ignore it — signal issues are usually just network problems' },
    ],
    correctOptionIds: ['b'],
    explanation:
      'Sudden, unexplained loss of signal is a classic early sign of SIM-swap fraud. Contacting your network operator immediately can stop an attacker before they gain full account access.',
    difficulty: 'intermediate',
  },
  {
    id: 'q-password-1',
    episodeId: 'ep-password-fortress',
    quizId: 'quiz-password-101',
    type: 'multi_select',
    stem: 'Which of the following make a password stronger? (Select all that apply)',
    options: [
      { id: 'a', text: 'Using a unique password for every account' },
      { id: 'b', text: 'Using your name and birth year' },
      { id: 'c', text: 'Enabling multi-factor authentication' },
      { id: 'd', text: 'Using a long passphrase instead of a short word' },
    ],
    correctOptionIds: ['a', 'c', 'd'],
    explanation:
      'Unique passwords, multi-factor authentication, and long passphrases all significantly raise the difficulty of an account being compromised. Personal details like names and birth years are easy to guess.',
    difficulty: 'beginner',
  },
]
